export default __webpack_public_path__ + "static/media/hover6.8311b0b9.png";